import React, { useState } from "react";
import { Form, Input, Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const PostAnniversaryWishForm: React.FC = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<any[]>([]);  
  const [loading, setLoading]   = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFileChange = ({ fileList }: any) => {
    setFileList(fileList.slice(-1)); // Allow only one file at a time
  };

  // const handleSubmit = async (values: any) => {
  //   setIsSubmitting(true);
  //   try {
  //     const imageBase64 = fileList.length > 0
  //       ? await convertToBase64(fileList[0].originFileObj)
  //       : null;

  //     const payload = {
  //       EcardId: values.ecardId,
  //       NominatorId: values.nominatorId,
  //       NomineeId: values.nomineeId,
  //       Message: values.message,
  //       Image: imageBase64,
  //       AnniversaryDate: values.anniversaryDate,
  //       IsPublished: true,
  //     };

  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_URL}/api/WorkAnniversaryMilestoneService/PostAnniversaryWish`,
  //       payload
  //     );

  //     if (response.status === 200) {
  //       message.success(response.data.message);
  //       form.resetFields();
  //       setFileList([]);
  //     }
  //     else if(response.status === 400) {
  //       message.error("Invalid input. Please check your data.");
  //     }
 
  //   } catch (error) {
  //     message.error("Failed to post the wish. Please try again.");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleSubmit = async (values: any) => {
    if (fileList.length === 0) {
      message.error("Please select an image.");
      return;
    }
  
    const data = new FormData();
    data.append("NominatorId", values.nominatorId);
    data.append("NomineeId",  values.nomineeId);
    data.append("Message",    values.message);
    data.append("Image",      fileList[0].originFileObj); // auto‑name "Image"
  
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/WorkAnniversaryMilestoneService/wish`,
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      message.success("Wish posted!");
      form.resetFields();
      setFileList([]);
    } catch (err) {
      message.error("Upload failed.");
    }
  };

  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve((reader.result as string).split(",")[1]);
      reader.onerror = (error) => reject(error);
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      style={{ maxWidth: 600, margin: "0 auto", padding: 20 }}
    >
      {/* ‼️ E‑card and date are auto‑determined on the server,
           so we REMOVED those inputs */}
      <Form.Item
        label="Nominator ID"
        name="nominatorId"
        rules={[{ required: true, message: "Please enter your (nominator) ID" }]}
      >
        <Input placeholder="Enter Nominator ID" />
      </Form.Item>

      <Form.Item
        label="Nominee ID"
        name="nomineeId"
        rules={[{ required: true, message: "Please enter the Nominee ID" }]}
      >
        <Input placeholder="Enter Nominee ID" />
      </Form.Item>

      <Form.Item
        label="Message"
        name="message"
        rules={[{ required: true, message: "Please enter your message" }]}
      >
        <Input.TextArea rows={4} placeholder="Enter your message" />
      </Form.Item>

      <Form.Item label="Upload Image" required>
        <Upload
          listType="picture"
          beforeUpload={() => false}             /* prevent auto‑upload */
          fileList={fileList}
          onChange={handleFileChange}
        >
          <Button icon={<UploadOutlined />}>Select image</Button>
        </Upload>
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          block
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PostAnniversaryWishForm;
